import { PlanTable } from './PlanTable'
import { StyledBox, StyledDrawer } from './ReplenishmentPlan.styles.ts'
import ReplaceProductDrawer from './ReplaceProductDrawer/ReplaceProductDrawer.tsx'
import { useDispatch, useSelector } from 'react-redux'
import { selectReplaceProduct } from '@/data/replenishmentPlan/slice/replenishmentPlan.selectors.ts'
import { replenishmentPlanActions } from '@/data/replenishmentPlan/slice/replenishmentPlan.slice.ts'
import { useFetchAndSavePlan } from '@/data/replenishmentPlan/hooks/useFetchAndSavePlan.ts'
import { useEffect, useLayoutEffect, useState } from 'react'
import { PlanDrawerContainerContext } from './PlanDrawerContainerContext.ts'
import NoTransition from './NoTransition.tsx'

const ReplenishmentPlan = () => {
  const { fetchAndSavePlan } = useFetchAndSavePlan()

  useLayoutEffect(() => {
    void fetchAndSavePlan()
  }, [fetchAndSavePlan])

  const dispatch = useDispatch()

  const replaceProduct = useSelector(selectReplaceProduct)

  useEffect(() => {
    if (!replaceProduct) {
      dispatch(replenishmentPlanActions.setReplaceProductId(null))
    }
  }, [dispatch, replaceProduct])

  const onCloseDrawer = () => {
    dispatch(replenishmentPlanActions.setReplaceProductId(null))
  }

  const [container, setContainer] = useState<HTMLElement | null>(null)

  return (
    <StyledBox ref={setContainer}>
      <PlanDrawerContainerContext.Provider value={container}>
        <PlanTable />
      </PlanDrawerContainerContext.Provider>

      <StyledDrawer
        disableEnforceFocus
        anchor="right"
        open={Boolean(replaceProduct)}
        TransitionComponent={NoTransition}
        container={container}
        hideBackdrop
        ModalProps={{
          // Non-blocking: the plan stays editable while the drawer is open
          slotProps: {
            root: { style: { position: 'absolute', pointerEvents: 'none' } },
          },
        }}
        PaperProps={{ style: { position: 'absolute', pointerEvents: 'auto' } }}
        onClose={onCloseDrawer}
      >
        <ReplaceProductDrawer
          product={replaceProduct}
          onClose={onCloseDrawer}
        />
      </StyledDrawer>
    </StyledBox>
  )
}

export default ReplenishmentPlan
